import {BaseService} from "./Core/BaseService";

/**
 * Client for the nested /api/contacts/{stakeholderId}/relationships endpoints.
 * URLs are built per-call from the parent stakeholderId — there is no flat root.
 */
class ProjectStakeholderRelationshipService extends BaseService {
    get ModelName() { return "Project Stakeholder Relationship"; }
    get PrimaryKeyProperty() { return "projectStakeholderRelationshipId"; }

    GetAll(stakeholderId) {
        return this.SendRequest(BaseService.GET, null, null,
            `/contacts/${stakeholderId}/relationships`);
    }

    /**
     * Idempotent — if the (stakeholderId, projectId, relationshipId) link
     * already exists the server returns the existing row unchanged.
     */
    Create(stakeholderId, projectId, relationshipId) {
        return this.SendRequest(BaseService.POST, {projectId, relationshipId}, null,
            `/contacts/${stakeholderId}/relationships`);
    }

    Delete(stakeholderId, projectStakeholderRelationshipId) {
        return this.SendRequest(BaseService.DELETE, projectStakeholderRelationshipId, null,
            `/contacts/${stakeholderId}/relationships`);
    }
}

export const service = new ProjectStakeholderRelationshipService();
